import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNewnav = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 300,
	height: 180,
	viewBox: "0 0 300 180",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_1893_18400)",
			children: [
				/* @__PURE__ */ _jsx("rect", {
					width: 300,
					height: 180,
					rx: 10,
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "path-3-inside-1_1893_18400",
					fill: "white",
					children: /* @__PURE__ */ _jsx("path", { d: "M0 0H80V180H0V0Z" })
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M0 0H80V180H0V0Z",
					fill: "#F0F9FF"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M80 0H79V180H80H81V0H80Z",
					fill: "#BCE1FA",
					mask: "url(#path-3-inside-1_1893_18400)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M15.3981 12.9744C18.7219 13.6193 19.7535 16.7043 19.7807 19.8072C19.7813 19.877 19.7251 19.934 19.6555 19.934H15.4715C15.4025 19.934 15.3463 19.8781 15.3459 19.8088C15.3334 17.4015 14.9444 15.2771 12.5654 15.1854C12.4944 15.1827 12.4352 15.2397 12.4352 15.311V19.8084C12.4352 19.8778 12.3792 19.934 12.31 19.934H8.12524C8.05609 19.934 8 19.8779 8 19.8084V8.34876C8 8.27944 8.05609 8.2232 8.12524 8.2232H12.31C12.3792 8.2232 12.4352 8.27944 12.4352 8.34876V12.6415C12.4352 12.7052 12.4867 12.7568 12.5502 12.7568C12.6006 12.7568 12.6454 12.724 12.66 12.6755C13.738 9.13555 15.7512 8.24545 19.0203 8.22356C19.0896 8.22307 19.1465 8.27956 19.1465 8.34913V12.6313C19.1465 12.7006 19.0904 12.7568 19.0212 12.7568H15.4191C15.3586 12.7568 15.3096 12.806 15.3096 12.8666C15.3096 12.9192 15.3468 12.9645 15.3981 12.9744ZM26.8546 15.6579V12.8824C26.8546 12.8131 26.9107 12.7568 26.9798 12.7568H30.0593C30.1199 12.7568 30.169 12.7076 30.169 12.6468C30.169 12.5941 30.1316 12.549 30.08 12.5388C27.6706 12.0597 26.5584 10.669 26.52 8.34889C26.5189 8.27993 26.5741 8.2232 26.6428 8.2232H31.1646C31.2337 8.2232 31.2898 8.27944 31.2898 8.34876V10.3033C31.2898 10.3726 31.3459 10.4289 31.4151 10.4289H34.0079C34.077 10.4289 34.1331 10.4851 34.1331 10.5545V12.6313C34.1331 12.7006 34.077 12.7568 34.0079 12.7568H31.4151C31.3459 12.7568 31.2898 12.8131 31.2898 12.8824V15.1211C31.2898 15.9121 31.7735 16.1728 32.4166 16.1728C33.4245 16.1728 34.4187 15.7175 34.8174 15.5111C34.9009 15.468 35 15.5287 35 15.6228V19.1079C35 19.2009 34.9488 19.2865 34.8666 19.3299C34.473 19.5375 33.2559 20.1131 31.8637 20.1131C29.0004 20.1134 26.8546 18.943 26.8546 15.6579ZM20.9683 19.8084V12.8822C20.9683 12.8128 21.0244 12.7566 21.0936 12.7566H25.2783C25.3475 12.7566 25.4036 12.8128 25.4036 12.8822V19.8084C25.4036 19.8778 25.3475 19.934 25.2783 19.934H21.0936C21.0244 19.934 20.9683 19.8779 20.9683 19.8084ZM20.7314 10.0214C20.7314 11.2003 21.5617 12.156 23.157 12.156C24.7523 12.156 25.5826 11.2003 25.5826 10.0214C25.5826 8.84248 24.7521 7.88672 23.157 7.88672C21.5617 7.88672 20.7314 8.84248 20.7314 10.0214Z",
					fill: "#1E1E1E"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 8,
					y: 36,
					width: 64,
					height: 8,
					rx: 4,
					fill: "#81C5F3"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 8,
					y: 52,
					width: 64,
					height: 8,
					rx: 4,
					fill: "#81C5F3"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 8,
					y: 68,
					width: 64,
					height: 8,
					rx: 4,
					fill: "#81C5F3"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 8,
					y: 84,
					width: 64,
					height: 8,
					rx: 4,
					fill: "#81C5F3"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 8,
					y: 100,
					width: 64,
					height: 8,
					rx: 4,
					fill: "#81C5F3"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 8,
					y: 116,
					width: 64,
					height: 8,
					rx: 4,
					fill: "#81C5F3"
				}),
				/* @__PURE__ */ _jsx("rect", {
					x: 7.5,
					y: 163.5,
					width: 65,
					height: 9,
					rx: 4.5,
					stroke: "#63BBF9"
				}),
				/* @__PURE__ */ _jsxs("g", {
					clipPath: "url(#clip1_1893_18400)",
					children: [
						/* @__PURE__ */ _jsx("rect", {
							x: 88,
							y: 8,
							width: 204,
							height: 62,
							rx: 4,
							fill: "#F7F7F7"
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 88,
							y: 78,
							width: 204,
							height: 62,
							rx: 4,
							fill: "#F7F7F7"
						}),
						/* @__PURE__ */ _jsx("rect", {
							x: 88,
							y: 148,
							width: 204,
							height: 62,
							rx: 4,
							fill: "#F7F7F7"
						})
					]
				})
			]
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .5,
			y: .5,
			width: 299,
			height: 179,
			rx: 9.5,
			stroke: "#BCE1FA"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_1893_18400",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 300,
				height: 180,
				rx: 10,
				fill: "white"
			})
		}), /* @__PURE__ */ _jsx("clipPath", {
			id: "clip1_1893_18400",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 220,
				height: 180,
				fill: "white",
				transform: "translate(80)"
			})
		})] })
	]
});
export default SvgNewnav;
